import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Rocket, Sparkles, ArrowRight, HardHat, Clock, Package } from 'lucide-react';
import useProStatus from '../../hooks/useProStatus';

/**
 * Upgrade-Card auf dem Inhaber-Dashboard.
 * Erscheint NUR wenn Firma noch KEIN Pro-Abo hat.
 * Führt zur öffentlichen SmartVolt-Pro-Landingpage.
 */
const ProUpgradeCard = () => {
  const navigate = useNavigate();
  const pro = useProStatus();

  if (pro.loading || pro.active) return null;

  return (
    <Card
      className="relative overflow-hidden border-2 border-yellow-500/50 bg-gradient-to-br from-yellow-500/10 via-orange-500/5 to-black shadow-lg shadow-yellow-500/10"
      data-testid="pro-upgrade-card"
    >
      {/* Glow-Effekt oben rechts */}
      <div className="absolute -top-16 -right-16 w-48 h-48 bg-yellow-500/30 rounded-full blur-3xl pointer-events-none" />
      <CardContent className="relative p-6 lg:p-8">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-yellow-500/20 border border-yellow-500/40 text-yellow-300 text-[11px] font-semibold uppercase tracking-wider">
              <Sparkles className="h-3 w-3" /> Neu · SmartVolt Pro
            </div>
            <h2 className="text-white text-2xl lg:text-3xl font-bold mt-3">
              Bringe deinen Betrieb <span className="text-yellow-400">auf das nächste Level</span>
            </h2>
            <p className="text-gray-300 mt-2 max-w-xl">
              Mobiles Baustellenmanagement, Kolonnen-Zeiterfassung und digitaler Material-Freigabe-Workflow –
              alles direkt aus der SmartVolt-Plattform, die dein Team schon kennt.
            </p>
            <div className="flex flex-wrap gap-4 mt-4 text-sm text-gray-300">
              <span className="inline-flex items-center gap-1"><HardHat className="h-4 w-4 text-yellow-400" /> Baustellenmanagement</span>
              <span className="inline-flex items-center gap-1"><Clock className="h-4 w-4 text-yellow-400" /> Zeiterfassung</span>
              <span className="inline-flex items-center gap-1"><Package className="h-4 w-4 text-yellow-400" /> Materialbeschaffung</span>
            </div>
          </div>
          <div className="lg:flex-shrink-0">
            <Button
              size="lg"
              onClick={() => navigate('/pro')}
              className="w-full lg:w-auto bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-black font-bold px-6 py-6 text-base shadow-lg"
              data-testid="pro-upgrade-cta"
            >
              <Rocket className="h-5 w-5 mr-2" />
              Firma auf das nächste Level heben
              <ArrowRight className="h-5 w-5 ml-2" />
            </Button>
            <p className="text-xs text-gray-500 mt-2 text-center lg:text-right">
              Monatliches Abo · jederzeit kündbar
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProUpgradeCard;
